import layoutAdmin from "@/layouts/layoutAdmin.vue";
import dashboard from "@/views/module/dashboard/dashboard.vue";
import lcBankList from "@/views/module/lc/settingsManagement/lcBankList.vue";
import lcBankDetail from "@/views/module/lc/settingsManagement/lcBankDetail.vue";
import lcPaymentTermList from "@/views/module/lc/settingsManagement/lcPaymentTermList.vue";
import lcIncotermList from "@/views/module/lc/settingsManagement/lcIncotermList.vue";
import lcTypeList from "@/views/module/lc/settingsManagement/lcTypeList.vue";
import lcPortList from "@/views/module/lc/settingsManagement/lcPortList.vue";
import lcShippingMethodList from "@/views/module/lc/settingsManagement/lcShippingMethodList.vue";
import lcDocumentTypeList from "@/views/module/lc/settingsManagement/lcDocumentTypeList.vue";
import lcExchangeRateList from "@/views/module/lc/settingsManagement/lcExchangeRateList.vue";
import lcImportPi from "@/views/module/lc/lcImport/lcImportPi.vue";
import lcImportPiRecord from "@/views/module/lc/lcImport/lcImportPiRecord.vue";
import viewLcImportPi from "@/views/module/lc/lcImport/viewLcImportPi.vue";
import lcImportLcMaster from "@/views/module/lc/lcImport/lcImportLcMaster.vue";
import lcImportLcMasterRecord from "@/views/module/lc/lcImport/lcImportLcMasterRecord.vue";
import viewLcImportLcMaster from "@/views/module/lc/lcImport/viewLcImportLcMaster.vue";
import lcImportLcAmendment from "@/views/module/lc/lcImport/lcImportLcAmendment.vue";
import lcImportLcAmendmentRecord from "@/views/module/lc/lcImport/lcImportLcAmendmentRecord.vue";
import lcImportLcShipment from "@/views/module/lc/lcImport/lcImportLcShipment.vue";
import lcImportLcShipmentRecord from "@/views/module/lc/lcImport/lcImportLcShipmentRecord.vue";
import viewLcImportLcShipment from "@/views/module/lc/lcImport/viewLcImportLcShipment.vue";
import lcImportGnr from "@/views/module/lc/lcImport/lcImportGnr.vue";
import lcImportGnrRecord from "@/views/module/lc/lcImport/lcImportGnrRecord.vue";
import viewLcImportGnr from "@/views/module/lc/lcImport/viewLcImportGnr.vue";
import lcImportLcCosting from "@/views/module/lc/lcImport/lcImportLcCosting.vue";
import lcImportLcCostingRecord from "@/views/module/lc/lcImport/lcImportLcCostingRecord.vue";
import lcImportLcCostingView from "@/views/module/lc/lcImport/lcImportLcCostingView.vue";
import lcImportDocument from "@/views/module/lc/lcImport/lcImportDocument.vue";
import lcImportDocumentRecord from "@/views/module/lc/lcImport/lcImportDocumentRecord.vue";
import lcExportDocument from "@/views/module/lc/lcExport/document/lcExportDocument.vue";
import lcExportDocumentRecord from "@/views/module/lc/lcExport/document/lcExportDocumentRecord.vue";
import lcImportShipmentReport from "@/views/module/lc/lcImport/reports/lcImportShipmentReport.vue";
import lcImportAgingReport from "@/views/module/lc/lcImport/reports/lcImportAgingReport.vue";
import lcImportSupplierWiseReport from "@/views/module/lc/lcImport/reports/lcImportSupplierWiseReport.vue";
import lcImportBankWiseReport from "@/views/module/lc/lcImport/reports/lcImportBankWiseReport.vue";
import lcImportPiAllocationReport from "@/views/module/lc/lcImport/reports/lcImportPiAllocationReport.vue";
import lcImportRegisterReport from "@/views/module/lc/lcImport/reports/lcImportRegisterReport.vue";
import lcImportGrnReport from "@/views/module/lc/lcImport/reports/lcImportGrnReport.vue";
import lcImportCostingSummaryReport from "@/views/module/lc/lcImport/reports/lcImportCostingSummaryReport.vue";
import lcImportCostingHistoryReport from "@/views/module/lc/lcImport/reports/lcImportCostingHistoryReport.vue";


// LC Export
import lcExportMaster from "@/views/module/lc/lcExport/lcExportMaster.vue";
import lcExportMasterRecord from "@/views/module/lc/lcExport/lcExportMasterRecord.vue";
import viewExportLcMaster from "@/views/module/lc/lcExport/viewLcExportMaster.vue";

import lcExportPiCreate from "@/views/module/lc/lcExport/lcExportPi.vue";
import lcExportPiRecord from "@/views/module/lc/lcExport/lcExportPiRecord.vue";
import viewLcExportPi from "@/views/module/lc/lcExport/viewLcExportPi.vue";

import lcExportCommercialInnvoiceCreate from "@/views/module/lc/lcExport/commercial/commercialInvoiceCreate.vue";
import lcExportCommercialInnvoiceList from "@/views/module/lc/lcExport/commercial/commertialInvoiceList.vue";
import viewLcExportCommercialInnvoice from "@/views/module/lc/lcExport/commercial/commercialInvoiceView.vue";



export default [
  // LC Import Reports - Root level routes to match menu URLs
  {
    path: "/lc-import/reports/register",
    name: "lc-import-register-report",
    component: layoutAdmin,
    meta: {
      UserLoggedIn: true,
      breadcrumb: ["LC Import", "Reports", "LC Register"],
    },
    children: [
      {
        path: "",
        name: "lc-import-register-report-page",
        component: lcImportRegisterReport,
      },
    ],
  },
  {
    path: "/lc-import/reports/shipment",
    name: "lc-import-shipment-report",
    component: layoutAdmin,
    meta: {
      UserLoggedIn: true,
      breadcrumb: ["LC Import", "Reports", "LC Shipment"],
    },
    children: [
      {
        path: "",
        name: "lc-import-shipment-report-page",
        component: lcImportShipmentReport,
      },
    ],
  },
  {
    path: "/lc-import/reports/aging",
    name: "lc-import-aging-report",
    component: layoutAdmin,
    meta: {
      UserLoggedIn: true,
      breadcrumb: ["LC Import", "Reports", "LC Aging"],
    },
    children: [
      {
        path: "",
        name: "lc-import-aging-report-page",
        component: lcImportAgingReport,
      },
    ],
  },
  {
    path: "/lc-import/reports/supplier-wise-lc",
    name: "lc-import-supplier-wise-report",
    component: layoutAdmin,
    meta: {
      UserLoggedIn: true,
      breadcrumb: ["LC Import", "Reports", "Supplier Wise LC"],
    },
    children: [
      {
        path: "",
        name: "lc-import-supplier-wise-report-page",
        component: lcImportSupplierWiseReport,
      },
    ],
  },
  {
    path: "/lc-import/reports/bank-wise-lc-exposure",
    name: "lc-import-bank-wise-report",
    component: layoutAdmin,
    meta: {
      UserLoggedIn: true,
      breadcrumb: ["LC Import", "Reports", "Bank Wise LC Exposure"],
    },
    children: [
      {
        path: "",
        name: "lc-import-bank-wise-report-page",
        component: lcImportBankWiseReport,
      },
    ],
  },
  {
    path: "/lc-import/reports/pi-allocation",
    name: "lc-import-pi-allocation-report",
    component: layoutAdmin,
    meta: {
      UserLoggedIn: true,
      breadcrumb: ["LC Import", "Reports", "LC PI Allocation"],
    },
    children: [
      {
        path: "",
        name: "lc-import-pi-allocation-report-page",
        component: lcImportPiAllocationReport,
      },
    ],
  },
  {
    path: "/lc-import/reports/lc-grn-vs-received-goods",
    name: "lc-import-grn-report",
    component: layoutAdmin,
    meta: {
      UserLoggedIn: true,
      breadcrumb: ["LC Import", "Reports", "LC-GRN (LC vs Received Goods)"],
    },
    children: [
      {
        path: "",
        name: "lc-import-grn-report-page",
        component: lcImportGrnReport,
      },
    ],
  },
  {
    path: "/lc-import/reports/costing-summary",
    name: "lc-import-costing-summary-report",
    component: layoutAdmin,
    meta: {
      UserLoggedIn: true,
      breadcrumb: ["LC Import", "Reports", "LC Costing Summary"],
    },
    children: [
      {
        path: "",
        name: "lc-import-costing-summary-report-page",
        component: lcImportCostingSummaryReport,
      },
    ],
  },
  {
    path: "/lc-import/reports/costing-history",
    name: "lc-import-costing-history-report",
    component: layoutAdmin,
    meta: {
      UserLoggedIn: true,
      breadcrumb: ["LC Import", "Reports", "LC Costing History"],
    },
    children: [
      {
        path: "",
        name: "lc-import-costing-history-report-page",
        component: lcImportCostingHistoryReport,
      },
    ],
  },
  {
    path: "/lc",
    name: "lc",
    component: layoutAdmin,
    meta: {
      UserLoggedIn: true,
      breadcrumb: "LC Management",
    },
    children: [
      {
        path: "dashboard",
        meta: {
          breadcrumb: ["Dashboard"],
        },
        component: dashboard,
      },
      // LC Banks
      
      {
        path: "banks/:id",
        name: "lc-bank-detail",
        meta: {
          breadcrumb: ["Settings", "LC Banks", "Bank Detail"],
        },
        component: lcBankDetail,
      },

      // LC Import - Proforma Invoice (PI)
      {
        path: "import-pi-create",
        name: "lc-import-pi",
        meta: {
          breadcrumb: ["LC Import", "Create PI"],
        },
        component: lcImportPi,
      },
      {
        path: "import-pi-create/:id",
        name: "lc-import-pi-edit",
        meta: {
          breadcrumb: ["LC Import", "Edit PI"],
        },
        component: lcImportPi,
      },
      {
        path: "import-pi-record",
        name: "lc-import-pi-records",
        meta: {
          breadcrumb: ["LC Import", "PI Records"],
        },
        component: lcImportPiRecord,
      },
      {
        path: "import-pi-view/:id",
        name: "lc-import-pi-view",
        meta: {
          breadcrumb: ["LC Import", "PI Details"],
        },
        component: viewLcImportPi,
      },
      // LC Import - LC Master
      {
        path: "import-lc-create",
        name: "lc-import-lc-master",
        meta: {
          breadcrumb: ["LC Import", "LC Create"],
        },
        component: lcImportLcMaster,
      },
      {
        path: "import-lc-create/:id",
        name: "lc-import-lc-master-edit",
        meta: {
          breadcrumb: ["LC Import", "Edit LC"],
        },
        component: lcImportLcMaster,
      },
      {
        path: "import-lc-record",
        name: "lc-import-lc-master-records",
        meta: {
          breadcrumb: ["LC Import", "LC Master Records"],
        },
        component: lcImportLcMasterRecord,
      },
      {
        path: "import-lc-view/:id",
        name: "lc-import-lc-master-view",
        meta: {
          breadcrumb: ["LC Import", "LC Master Details"],
        },
        component: viewLcImportLcMaster,
      },
      // LC Import - LC Amendment
      {
        path: "import-lc-amendment",
        name: "lc-import-lc-amendment",
        meta: {
          breadcrumb: ["LC Import", "LC Amendment Records"],
        },
        component: lcImportLcAmendmentRecord,
      },
      {
        path: "import-lc-amendment-create",
        name: "lc-import-lc-amendment-create",
        meta: {
          breadcrumb: ["LC Import", "Create Amendment"],
        },
        component: lcImportLcAmendment,
      },
      {
        path: "import-lc-amendment-record",
        name: "lc-import-lc-amendment-records",
        meta: {
          breadcrumb: ["LC Import", "LC Amendment Records"],
        },
        component: lcImportLcAmendmentRecord,
      },
      // LC Import - LC Shipment
      {
        path: "import-lc-shipment-create/:id?",
        name: "lc-import-lc-shipment-create",
        meta: {
          breadcrumb: ["LC Import", "Create Shipment"],
        },
        component: lcImportLcShipment,
      },
      {
        path: "import-lc-shipment-record",
        name: "lc-import-lc-shipment-records",
        meta: {
          breadcrumb: ["LC Import", "Shipment Records"],
        },
        component: lcImportLcShipmentRecord,
      },
      {
        path: "import-lc-shipment-view/:id",
        name: "lc-import-lc-shipment-view",
        meta: {
          breadcrumb: ["LC Import", "Shipment Details"],
        },
        component: viewLcImportLcShipment,
      },
      // LC Import - GRN
      {
        path: "import-lc-gnr-create",
        name: "lc-import-gnr-create",
        meta: {
          breadcrumb: ["LC Import", "Create GRN"],
        },
        component: lcImportGnr,
      },
      {
        path: "import-lc-gnr-create/:id",
        name: "lc-import-gnr-edit",
        meta: {
          breadcrumb: ["LC Import", "Edit GRN"],
        },
        component: lcImportGnr,
      },
      {
        path: "import-lc-gnr-record",
        name: "lc-import-gnr-records",
        meta: {
          breadcrumb: ["LC Import", "GRN Records"],
        },
        component: lcImportGnrRecord,
      },
      {
        path: "import-lc-gnr-view/:id",
        name: "lc-import-gnr-view",
        meta: {
          breadcrumb: ["LC Import", "GRN Details"],
        },
        component: viewLcImportGnr,
      },
      // LC Import - LC Costing
      {
        path: "import-lc-costing-create/:id?",
        name: "lc-import-lc-costing-create",
        meta: {
          breadcrumb: ["LC Import", "Create Costing"],
        },
        component: lcImportLcCosting,
      },
      {
        path: "import-lc-costing-create/:id",
        name: "lc-import-lc-costing-edit",
        meta: {
          breadcrumb: ["LC Import", "Edit Costing"],
        },
        component: lcImportLcCosting,
      },
      {
        path: "import-lc-costing-record",
        name: "lc-import-lc-costing-records",
        meta: {
          breadcrumb: ["LC Import", "Costing Records"],
        },
        component: lcImportLcCostingRecord,
      },

      {
        path: "lc-import-lc-costing-view/:id",
        name: "lc-import-lc-costing-view",
        meta: {
          breadcrumb: ["LC Import", "Costing Records"],
        },
        component: lcImportLcCostingView,
      },
      {
        path: "import-document-create",
        name: "lc-import-document-create",
        meta: {
          breadcrumb: ["LC Import", "Create Document"],
        },
        component: lcImportDocument,
      },
      {
        path: "import-document-create/:id",
        name: "lc-import-document-edit",
        meta: {
          breadcrumb: ["LC Import", "Edit Document"],
        },
        component: lcImportDocument,
      },
      {
        path: "import-document-records",
        name: "lc-import-document-records",
        meta: {
          breadcrumb: ["LC Import", "Document Records"],
        },
        component: lcImportDocumentRecord,
      },
      {
        path: "export-document-create/:id?",
        name: "export-document-create",
        meta: {
          breadcrumb: ["LC Export", "Create Document"],
        },
        component: lcExportDocument,
      },
      {
        path: "export-document-records",
        name: "export-document-records",
        meta: {
          breadcrumb: ["LC Export", "Document Records"],
        },
        component: lcExportDocumentRecord,
      },

      {
        path: "export-lc-document-create/:id?",
        name: "export-lc-document-create",
        meta: {
          breadcrumb: ["LC Export", "Create Document"],
        },
        component: lcExportDocument,
      },
      {
        path: "export-lc-document",
        name: "export-lc-document",
        meta: {
          breadcrumb: ["LC Export", "Document Records"],
        },
        component: lcExportDocumentRecord,
      },
      {
        path: "export-lc-create/:id?",
        name: "export-lc-create",
        meta: {
          breadcrumb: ["LC Export", "Export LC Cretate"],
        },
        component: lcExportMaster,
      },
      {
        path: "export-lc-record",
        name: "export-lc-record",
        meta: {
          breadcrumb: ["LC Export", "Export LC Record"],
        },
        component: lcExportMasterRecord,
      },
      {
        path: "export-lc-view/:id",
        name: "export-lc-view",
        meta: {
          breadcrumb: ["LC Export", "Export LC View"],
        },
        component: viewExportLcMaster,
      },
      {
        path: "export-pi-create/:id?",
        name: "export-pi-create",
        meta: {
          breadcrumb: ["LC Export", "Export PI Cretate"],
        },
        component: lcExportPiCreate,
      },
      {
        path: "export-pi-record",
        name: "export-pi-record",
        meta: {
          breadcrumb: ["LC Export", "Export PI Record"],
        },
        component: lcExportPiRecord,
      },
      {
        path: "export-pi-view/:id",
        name: "export-pi-view",
        meta: {
          breadcrumb: ["LC Export", "Export PI View"],
        },
        component: viewLcExportPi,
      },


      {
        path: "export-commercial-invoice-create/:id?",
        name: "export-commercial-invoice-create",
        meta: {
          breadcrumb: ["LC Export", "Create Commercial Invoice"],
        },
        component: lcExportCommercialInnvoiceCreate,
      },
      {
        path: "export-commercial-invoice-record",
        name: "export-commercial-invoice-record",
        meta: {
          breadcrumb: ["LC Export", "Commercial Invoice List"],
        },
        component: lcExportCommercialInnvoiceList,
      },
      {
        path: "export-commercial-invoice-view/:id",
        name: "export-commercial-invoice-view",
        meta: {
          breadcrumb: ["LC Export", "Commercial Invoice"],
        },
        component: viewLcExportCommercialInnvoice,
      },



    ],
  },
];

